import { CoffeeToGoIcon } from './CoffeeToGoIcon';

/**
 * author: Austin Andrews
 * id 8093CDE7-C795-4415-94C6-2EF40ED6D057
 * name coffee-to-go
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-to-go.svg
 * tags
 * - Food / Drink 
 */
export const FreeBreakfastToGoIcon = CoffeeToGoIcon;
export default FreeBreakfastToGoIcon